<template>
  <div class="count-page">
    <el-descriptions class="margin-top" :column="3">
      <el-descriptions-item label="入库单号">{{inBoundOrder.order_id}}</el-descriptions-item>
      <el-descriptions-item label="入库仓库">{{inBoundOrder.warehouse}}</el-descriptions-item>
      <el-descriptions-item label="入库单类型">{{inBoundOrder.order_type}}</el-descriptions-item>
      <el-descriptions-item label="运输单号">{{inBoundOrder.way_bill_no}}</el-descriptions-item>
      <el-descriptions-item label="总箱数">{{inBoundOrder.pack_qty}}</el-descriptions-item>
      <el-descriptions-item label="物品总数">{{inBoundOrder.item_qty}}</el-descriptions-item>
      <el-descriptions-item label="责任人">{{inBoundOrder.charge_user_id}}</el-descriptions-item>
      <el-descriptions-item label="领取时间">{{inBoundOrder.take_time}}</el-descriptions-item>
    </el-descriptions>
    <h2 style="width: 100%;text-align: center">入库单明细</h2>
    <el-table :data="inBoundOrder.order_item_list" style="width: 100%" stripe default-expand-all>
      <el-table-column type="expand">
        <template #default="scope">
          <div style="margin: 20px" v-if="scope.row.sn_flag">
            <h2 style="width: 100%;text-align: center">序列号装箱信息</h2>
            <div style="margin-bottom: 20px">
              <text style="font-size: 20px">物品序列号：</text>
              <el-input style="width: 300px" clearable v-model="scope.row.itemSn" placeholder="请扫描物品序列号"></el-input>
              <el-button type="primary" style="margin-left: 20px" :loading="loading.itemSnBtn" @click="submitItemSn(scope.row)">提交序列号</el-button>
            </div>
            <div v-for="(item,index) in scope.row.packing_info" :key="index">
              <div><text style="font-weight: bold">装箱箱码：</text>{{item.packing_sn}}</div>
              <div>
                <text style="font-weight: bold">箱内序列号明细：</text>
                <div v-for="(sns,idx) in item.packing_sn_list" :key="idx" style="display: flex;flex-wrap: nowrap;margin-left: 100px">
                  <div v-for="sn in sns" :key="sn.item_sn" style="width: 200px;font-weight: bold" :style="{color: sn.is_received ? '#008000':'#FFA500'}">
                    {{sn.item_sn}}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="scope.row.problem_list.length > 0">
              <text style="font-weight: bold;color: red">异常序列号明细：</text>
              <div v-for="(problems,idx) in scope.row.problem_list" :key="idx" style="display: flex;flex-wrap: nowrap;margin-left: 100px">
                <div v-for="problem in problems" :key="problem.id" style="width: 200px;font-weight: bold;color: red">
                  {{problem.problem_code}}
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div style="margin: 20px">
              <div><text style="font-weight: bold">入库单数量：</text>{{scope.row.item_qty}}</div>
              <div><text style="font-weight: bold">实际收货数量：</text>
                <el-input-number v-model="scope.row.actual_item_qty" :min="0" :max="999999" style="width: 200px"></el-input-number>
              </div>
              <el-button type="primary" :loading="loading.itemQtyBtn" @click="submitItemQty(scope.row)">提交收货数量</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="item_code" label="物料代码"></el-table-column>
      <el-table-column prop="item_name" label="物料描述"></el-table-column>
      <el-table-column prop="item_name_en" label="物料描述(英文)"></el-table-column>
      <el-table-column prop="positions" label="物料库位"></el-table-column>
      <el-table-column prop="item_qty" align="center" label="箱内数量" width="80"></el-table-column>
      <el-table-column prop="sn_flag" align="center" label="是否SN管控物料" width="130"></el-table-column>
      <el-table-column prop="is_with_battery" align="center" label="是否带电" width="80"></el-table-column>
      <el-table-column prop="battery_type" align="center" label="电池类型" width="80"></el-table-column>
    </el-table>
    <div style="width: 100%;text-align: center;margin: 20px 0">
      <el-button type="success" :loading="loading.submitFinishBtn" @click="submitCountFinish">入库单点货完成</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DjiInBoundOrderCount",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      itemSn: '',
      inBoundOrder: {},
      loading:{
        itemSnBtn:false,
        itemQtyBtn:false,
        submitFinishBtn: false
      }
    }
  },
  async created() {
    await this.getInBoundOrderCount();
  },
  methods: {
    async submitCountFinish(){
      this.loading.submitFinishBtn = true;
      this.$http('inBoundService.submitCountFinish', {id: this.inBoundOrder.order_id}, false).then(data => {
        this.loading.submitFinishBtn = false;
        this.$message.success("提交点货成功");
        this.getInBoundOrderCount();
      }, errMsg => {
        this.loading.submitFinishBtn = false;
        return this.$message.error(errMsg);
      })
    },
    async submitItemQty(row){
      this.loading.itemQtyBtn = true;
      this.$http('inBoundService.submitItemQty', {id: row.order_id, actual_item_qty: row.actual_item_qty, item_id: row.id}, false).then(data => {
        this.loading.itemQtyBtn = false;
        this.$message.success("收货成功");
        this.getInBoundOrderCount();
      }, errMsg => {
        this.loading.itemQtyBtn = false;
        return this.$message.error(errMsg);
      })
    },
    async submitItemSn(row) {
      this.loading.itemSnBtn = true;
      this.$http('inBoundService.submitItemSn', {id: row.order_id, item_sn: row.itemSn, item_id: row.id}, false).then(data => {
        this.loading.itemSnBtn = false;
        this.$message.success(row.itemSn+"收货成功");
        this.getInBoundOrderCount();
      }, errMsg => {
        this.loading.itemSnBtn = false;
        return this.$message.error(errMsg);
      })
      //
      // let data = await this.$http('inBoundService.submitItemSn', {id: row.order_id, item_sn: row.itemSn, item_id: row.id});
      // if (!data){
      //   this.$confirm('SN不存在，确定提交当前点货SN吗？', '警告', {
      //     cancelButtonText: '取消',
      //     confirmButtonText: '确定',
      //     type: 'error'
      //   }).then(async () => {
      //     // eslint-disable-next-line no-unused-vars
      //     let data = await this.$http('inBoundService.submitProblemSn', {id: row.order_id, item_sn: row.itemSn, item_id: row.id})
      //     this.$message.success("提交成功")
      //     this.getInBoundOrderCount();
      //   }).catch(() => {
      //   })
      // }else {
      //   this.$message.success(this.itemSn+"收货成功");
      //   this.getInBoundOrderCount();
      // }
    },
    //获取入库单明细
    async getInBoundOrderCount() {
      let data = await this.$http('inBoundService.getInBoundOrder', {id: this.parentData.id,});
      this.inBoundOrder = data;
    }
  }
}
</script>


<style scoped lang="less">
.count-page{
  margin: 10px;
}
</style>